module.exports = __webpack_public_path__ + "img/02030210.faa577ec.svg";